import { daysUntil, alertLevel, alertStyles, alertLabel } from "../lib/alerts";

export const AlertBadge = ({ dateStr, label, testid }) => {
  const days = daysUntil(dateStr);
  const level = alertLevel(days);
  return (
    <div
      data-testid={testid}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border-2 font-bold text-xs ${alertStyles[level]}`}
    >
      <span className="w-2 h-2 rounded-full bg-current opacity-80" />
      {label}
      {days !== null ? (
        <span className="font-mono-plate">
          {days < 0 ? `${Math.abs(days)}j de retard` : `${days}j`}
        </span>
      ) : (
        <span className="opacity-70">—</span>
      )}
    </div>
  );
};

export const StatusDot = ({ dateStr }) => {
  const level = alertLevel(daysUntil(dateStr));
  return (
    <span
      title={alertLabel[level]}
      className={`inline-block w-3.5 h-3.5 rounded-full border-2 border-slate-900 ${
        level === "green"
          ? "bg-[#4ADE80]"
          : level === "orange"
          ? "bg-[#FB923C]"
          : level === "red"
          ? "bg-[#EF4444]"
          : "bg-slate-200"
      }`}
    />
  );
};
